import { Routes } from '@angular/router';
import { BouncyCastleComponent } from './components/pages/bouncy-castle/bouncy-castle.component';
import { HomeComponent } from './components/pages/home/home.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { SweetsAndDrinksComponent } from './components/pages/sweets-and-drinks/sweets-and-drinks.component';
import { ToysComponent } from './components/pages/toys/toys.component';
import { ImprintComponent } from './components/pages/imprint/imprint.component';
import { PrivacyNoticeComponent } from './components/pages/privacy-notice/privacy-notice.component';
import { UseAndSaleComponent } from './components/pages/use-and-sale/use-and-sale.component';

export const routes: Routes = [
    { path: 'home', component: HomeComponent, data: { title: 'routes.home' } },
    { path: 'bouncy-castle', component: BouncyCastleComponent, data: { title: 'routes.bouncy-castle' } },
    { path: 'sweets-and-drinks', component: SweetsAndDrinksComponent, data: { title: 'routes.sweets-and-drinks' } },
    { path: 'toys', component: ToysComponent, data: { title: 'routes.toys' } },
    { path: 'imprint', component: ImprintComponent, data: { title: 'routes.imprint' } },
    { path: 'privacy-notice', component: PrivacyNoticeComponent, data: { title: 'routes.privacy-notice' } },
    { path: 'conditions-of-use-and-sale', component: UseAndSaleComponent, data: { title: 'routes.conditions-of-use-and-sale' } },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent, data: { title: 'routes.page-not-found' } }
];
